<div class="bmc-ecm-container-folders" (click)="$event.stopPropagation()" *ngIf="selectedRepository">
    <div class="bmc-ecm-container-folders__title-container">
        <label class="bmc-ecm-container-folders__title">{{'ECM.FOLDERS' | translate}}</label>
        <bzg-select #selectFolders [placeholder]="'ECM.SELECT_FOLDER' | translate" (valueChange)="selectFolder($event)">
            <bzg-option *ngFor="let folder of selectedRepository.nodes" [value]="folder">
                {{folder.displayName}}
            </bzg-option>
        </bzg-select>
    </div>
    <div *ngIf="selectedFolder">
        <div class="bmc-ecm-container-folders__field">
            <div class="bmc-ecm-container-folders__field__text">
                <label>{{'ECM.FOLDER_PATH' | translate}}</label>
            </div>
            <div class="bmc-ecm-container-folders__field__value">
                <bzg-input class="bmc-ecm-container-folders__path__input" [disabled]="true"
                    [(ngModel)]="selectedFolder.environment.params.path"></bzg-input>
            </div>
        </div>

        <div class="bmc-ecm-container-folders__field bmc-ecm-container-folders__field--ecm-system bz-space--stack-m">
            <div class="bmc-ecm-container-folders__field__text ">
                <label>{{'ECM.FOLDERS_ECM_SYTEM' | translate}}</label>
            </div>
            <div class="bmc-ecm-container-folders__field__value">
                <div class="bmc-ecm-container-folders-list">
                    <div class="bmc-ecm-container-folders-list__item bmc-ecm-container-folders-list__repository-name">
                        <bzg-icon [nameIcon]="'icon-production'"></bzg-icon>
                        <label>{{selectedRepository.environment.params.repositoryName}}</label>
                    </div>
                    <connect-ecm-folders-list [selectedRepository]="selectedRepository"
                        [selectedFolder]="selectedFolder"
                        [parentName]="selectedRepository.environment.params.repositoryName"
                        [style.display]="showLoadingNodes ? 'none' : 'block'" [foldersAvailable]="foldersAvailable"
                        (onShowLoadingNodes)="showLoadingNodes = $event">
                    </connect-ecm-folders-list>
                    <bz-loading [showLoading]="showLoadingNodes"></bz-loading>
                </div>
            </div>
        </div>
    </div>

</div>
